/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestGetReportItemsCsvListRequest
 */
export interface RequestGetReportItemsCsvListRequest {
    /**
     * 
     * @type {string}
     * @memberof RequestGetReportItemsCsvListRequest
     */
    shippedDate?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestGetReportItemsCsvListRequest
     */
    tenantId: number;
}

/**
 * Check if a given object implements the RequestGetReportItemsCsvListRequest interface.
 */
export function instanceOfRequestGetReportItemsCsvListRequest(value: object): value is RequestGetReportItemsCsvListRequest {
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    return true;
}

export function RequestGetReportItemsCsvListRequestFromJSON(json: any): RequestGetReportItemsCsvListRequest {
    return RequestGetReportItemsCsvListRequestFromJSONTyped(json, false);
}

export function RequestGetReportItemsCsvListRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestGetReportItemsCsvListRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'shippedDate': json['shipped_date'] == null ? undefined : json['shipped_date'],
        'tenantId': json['tenant_id'],
    };
}

export function RequestGetReportItemsCsvListRequestToJSON(json: any): RequestGetReportItemsCsvListRequest {
    return RequestGetReportItemsCsvListRequestToJSONTyped(json, false);
}

export function RequestGetReportItemsCsvListRequestToJSONTyped(value?: RequestGetReportItemsCsvListRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shipped_date': value['shippedDate'],
        'tenant_id': value['tenantId'],
    };
}

